import React, { createContext, useState, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import Lurker from '../lurker'

const lurker = new Lurker('revalidation')

const initialData = {
  legalDocument: {
    value: '',
    validated: false,
    type: '',
  },
  phone: {
    value: '',
    validated: false,
  },
  email: {
    value: '',
    validated: false,
  },
}

export const RevalidationContext = createContext({ ...initialData, lurker })

const RevalidationProvider = ({ token, children }) => {
  const [validations, setValidations] = useState(initialData)
  const [emailsInUse, setEmailsInUse] = useState([])
  const [pinCode, setPinCode] = useState('')
  const [sendEmailRequestId, setSendEmailRequestId] = useState('')
  const [oldEmail, setOldEmail] = useState('')
  const [oldPhone, setOldPhone] = useState('')

  const updateValidations = (validationName, value) => {
    setValidations({ ...validations, [validationName]: { value, validated: false } })
  }

  const setDataValidations = newValidations => {
    setOldEmail(newValidations?.email?.value)
    setOldPhone(newValidations?.phone?.value)
    setValidations({ ...validations, ...newValidations })
  }

  const updateEmailsInUse = emails => setEmailsInUse(emails)
  const updatePinCode = pinCode => setPinCode(pinCode)
  const updateSendEmailRequestId = requestId => setSendEmailRequestId(requestId)

  const value = useMemo(() => {
    return {
      ...validations,
      token,
      emailsInUse,
      pinCode,
      lurker,
      sendEmailRequestId,
      oldEmail,
      oldPhone,
      updateValidations,
      updateEmailsInUse,
      updatePinCode,
      setDataValidations,
      updateSendEmailRequestId,
    }
  }, [validations, token, emailsInUse, pinCode, lurker, sendEmailRequestId])

  return <RevalidationContext.Provider value={value}>{children}</RevalidationContext.Provider>
}

export default RevalidationProvider

RevalidationContext.Provider.propTypes = {
  token: PropTypes.string,
  phone: PropTypes.shape({
    value: PropTypes.string,
    validated: PropTypes.bool,
  }),
  legalDocument: PropTypes.shape({
    value: PropTypes.string,
    validated: PropTypes.bool,
  }),
  email: PropTypes.shape({
    value: PropTypes.string,
    validated: PropTypes.bool,
  }),
  emailsInUse: PropTypes.arrayOf(PropTypes.string),
  pinCode: PropTypes.string,
  updateValidations: PropTypes.func,
  updateEmailsInUse: PropTypes.func,
  updatePinCode: PropTypes.func,
  lurker: PropTypes.object,
  sendEmailRequestId: PropTypes.string,
  oldPhone: PropTypes.string,
  oldEmail: PropTypes.string,
}
